import { useCallback } from "react";

import { useSelector } from "react-redux";

import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { CrmRecordsResponseDto } from "app/pages/sales-intelligence/domain/crm-integration/types/records";
import { useCompanyCrmRecordsQuery } from "app/pages/sales-intelligence/modules/crm-integration/query/queries/useCompanyCrmRecordsQuery";
import { createCrmRecordsColumList } from "app/pages/sales-intelligence/modules/crm-integration/services/column-adapters/crm-records/factory";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { RootState } from "single-spa/store/types";

import { selectCrmRecordsRequestDto } from "../store/selectors";
import type { CrmRecordsTableData } from "../types/table";

const useFetchCrmRecordsTableResults = (domain: string, integrationProvider: CrmIntegrationProvider) => {
    const dto = useSelector((state: RootState) => selectCrmRecordsRequestDto(state, integrationProvider));

    const transformCrmRecordsData = useCallback(
        (data: CrmRecordsResponseDto): CrmRecordsTableData => ({
            ...data,
            columns: createCrmRecordsColumList(data.columns),
        }),
        [],
    );

    return useCompanyCrmRecordsQuery(
        { domain, integrationProvider, dto },
        salesSettingsHelper.isCrmCustomFiltersEnabled,
        transformCrmRecordsData,
    );
};

export default useFetchCrmRecordsTableResults;
